export default "__VITE_ASSET__1dfb54fe__"